import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const menuItems = [
  { path: '/', label: 'Dashboard', icon: '📊' },
  { path: '/managers', label: 'VIP Managers', icon: '👑' },
  { path: '/members', label: 'Members', icon: '👥' },
  { path: '/payments', label: 'Payments', icon: '💳' },
  { path: '/revenue', label: 'Revenue', icon: '💰' },
  { path: '/logs', label: 'Logs', icon: '📋' },
  { path: '/system', label: 'System', icon: '🖥️' },
  { path: '/settings', label: 'Settings', icon: '⚙️' },
  { path: '/group-messages', label: 'Group Messages', icon: '💬' },
];

const Sidebar = () => {
  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <span className="sidebar-logo">🛡️</span>
        <h2 className="sidebar-title">CM OS</h2>
      </div>
      <nav className="sidebar-nav">
        {menuItems.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <span className="sidebar-icon">{item.icon}</span>
            <span className="sidebar-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;